import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-steps',
  template: ` <router-outlet></router-outlet>`,
  styles: [
    `
      app-steps {
        display: block;
        overflow-x: hidden;
      }
    `,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class StepsComponent {}
